export const bannerSlider = () => {
  const allSliders = document.querySelectorAll('.js-bannerSlider')

  const engageSlider = (singleSlider: Element) => {
    const slider = tns({
      container: singleSlider,
      controlsContainer: singleSlider,
      controls: false,
      items: 1,
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      autoHeight: false,
      mouseDrag: true,
      swipeAngle: false,
      responsive: {
        768: {
          mouseDrag: false,
          autoHeight: false

        }
      }
    })
  }

  allSliders.forEach(slider => {
    engageSlider(slider)
  })
}
